import { GradFairGradProgramLinksBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { GradFairGradProgramLinksBlock } from './GradFairGradProgramLinksBlock';

export const GradFairGradProgramLinksBlockMapping: BlockMapping<GradFairGradProgramLinksBlockData> =
  {
    invariant: [],
    width: 'INSET',
    Component: GradFairGradProgramLinksBlock,
    AmpComponent: GradFairGradProgramLinksBlock,
  };
